




































































































































import mixins from 'vue-typed-mixins';
import { Escalation } from './Escalation';
import { EscalationVariables } from '../EscalationVariables';
import { EscalationType } from '../EscalationType';
import { EscalationGroup } from '../EscalationGroup';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityListComponentMixin from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import { TranslateResult } from 'vue-i18n';
import { AxiosResponse } from 'axios';
import VatsAPI from '@/Shared/VatsAPI';

const component = mixins(LocationBasedMixin, BuildEntityListComponentMixin<Escalation>()).extend({
    props: {
        escalationVariables: {
            required: true,
            type: Object as () => EscalationVariables
        }
    },
    data() {
        return {
            escalationGroups: [] as EscalationGroup[],
            i18nPrefix: 'admin.programVariables.escalationManagement.citationEscalations',
            EscalationType,
        };
    },
    computed: {
        currentGroup(): (groupId: number) => string {
            return (groupId: number) => {
                const group = this.escalationGroups.find(item => item.recID === groupId);
                if (group) {
                    return group.description;
                }
                return '';
            };
        },
        escalateAmountLabel(): string | TranslateResult {
            if (this.escalationVariables.escalationType === EscalationType.FixedValue) {
                return this.$t(`${this.i18nPrefix}.escalationFixedValueLabel`);
            }
            else if (this.escalationVariables.escalationType === EscalationType.Multiplier) {
                return this.$t(`${this.i18nPrefix}.escalationMultiplierLabel`);
            }
            else {
                return '';
            }
        },
        entityUrls() {
            return `${this.location}/Citations/EscalationVariables/Escalations`;
        },
    },
    methods: {
        formatEscalateAmount(escalationAmount: number): string {
            if (this.escalationVariables.escalationType === EscalationType.FixedValue) {
                return this.$n(escalationAmount, 'currency');
            }
            else if (this.escalationVariables.escalationType === EscalationType.Multiplier) {
                return `${escalationAmount.toLocaleString(this.$i18n.locale)}%`;
            }
            else {
                return escalationAmount.toLocaleString(this.$i18n.locale);
            }
        },
        afterSave(response: AxiosResponse<Escalation>) {
                response.data.fineEscalateStartDate = new Date(response.data.fineEscalateStartDate);
                return response.data;
        },
        afterLoad(response: AxiosResponse<Escalation[]>) {
                for (const esc of response.data) {
                    esc.fineEscalateStartDate = new Date(esc.fineEscalateStartDate);
                }
                return response.data;
        }
    },
    async mounted() {
        this.escalationGroups = (await VatsAPI.get<EscalationGroup[]>(`${this.location}/Citations/EscalationVariables/EscalationGroups`)).data;
    },
});

export default component;
